import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Empty, Tree } from "antd";
import React from "react";
import { Button } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import GenericPagination from "../GenericPagination";

const { TreeNode } = Tree;

const loop = (props, data) =>
  data.map(item => {
    return (
      <TreeNode
        key={item.key}
        title={
          <>
            {item.selectable && props.onClick ? (
              <div className="edit-button-div">
                <Button variant="link" onClick={() => props.onClick(item.key)}>
                  <FontAwesomeIcon
                    icon={
                      props.fontAwesomeIcon ? props.fontAwesomeIcon : faEdit
                    }
                    size="sm"
                  />
                </Button>
              </div>
            ) : null}
            {item.leaf ? (
              <div className="unclickable-tree-div">{item.name} </div>
            ) : (
              <div
                onClick={() => props.onSelect(item.key)}
                className="clickable-tree-div"
              >
                {item.name}
              </div>
            )}
          </>
        }
        dataRef={item}
        disabled={true}
        isLeaf={item.leaf}
      >
        {item.children && item.children.length
          ? loop(props, item.children)
          : null}
      </TreeNode>
    );
  });

const GenericTree = props => {
  return (
    <>
      {!props.data ? null : props.data.length > 0 ? (
        <div>
          <Tree
            className="draggable-tree"
            draggable={false}
            blockNode
            loadData={props.loadData}
            loadedKeys={props.loadedKeys}
            expandedKeys={props.expandedKeys}
            onExpand={props.onExpand}
          >
            {loop(props, props.data)}
          </Tree>
          <div className="d-flex justify-content-center">
            <GenericPagination
              size="sm"
              pageInfo={props.pageInfo}
              onPageNumberClick={props.onPageNumberClick}
            />
          </div>
        </div>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<span>{labels.noData}</span>}
        />
      )}
    </>
  );
};

export default GenericTree;
